import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";

const BASE_URL = process.env.REACT_APP_API_BASE_URL;
const locale = "sr";

export const groupTypesManagement = createApi({
    reducerPath: "groupTypesManagement",
    baseQuery: fetchBaseQuery({
        baseUrl: `${BASE_URL}`,
        prepareHeaders: (headers) => {
            const jwtToken = localStorage.getItem("userToken") || sessionStorage.getItem("userToken");

            if (jwtToken) {
                headers.set("authorization", `Bearer ${jwtToken}`);
            }

            return headers;
        },
    }),
    endpoints: (builder) => ({
        groupTypesList: builder.mutation({
            query: (body) => {
                let url = `v1/${locale}/settings/group-types`;

                for (const property in body) {
                    if ((property && body[property]) || (property === "startPage" && body[property] === 0)) {
                        if (url?.includes("?")) {
                            url += `&${property}=${body[property]}`;
                        } else {
                            url += `?${property}=${body[property]}`;
                        }
                    }
                }

                return {
                    url: url,
                    method: "GET",
                };
            },
        }),

        addGroupTypes: builder.mutation({
            query: (body) => ({
                url: `v1/${locale}/settings/group-types`,
                method: "POST",
                body: body,
            }),
        }),

        viewGroupTypes: builder.mutation({
            query: (groupTypeId) => ({
                url: `v1/${locale}/settings/group-types/${groupTypeId}`,
                method: "GET",
            }),
        }),

        deleteGroupTypes: builder.mutation({
            query: (groupTypeId) => ({
                url: `v1/${locale}/settings/group-types/${groupTypeId}`,
                method: "DELETE",
            }),
        }),

        updateGroupTypes: builder.mutation({
            query: ({ body, groupTypeId }) => ({
                url: `v1/${locale}/settings/group-types/${groupTypeId}`,
                method: "PATCH",
                body: body,
            }),
        }),
    }),
});

export const { 
    useGroupTypesListMutation,
    useAddGroupTypesMutation,
    useDeleteGroupTypesMutation,
    useViewGroupTypesMutation,
    useUpdateGroupTypesMutation,
} = groupTypesManagement;
